import { render, staticRenderFns } from "./ModalLicensePurchase.vue?vue&type=template&id=5d074b63&scoped=true&"
import script from "./ModalLicensePurchase.vue?vue&type=script&lang=js&"
export * from "./ModalLicensePurchase.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicensePurchase.vue?vue&type=style&index=0&id=5d074b63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d074b63",
  null
  
)

export default component.exports